// These are the inline styles used for the display of callsheets in-app and in email.
const styles = {
  tableHead: {
    textAlign: 'center',
    width: '50%'
  },
  tableCell: { 
    textAlign: 'center'
  },
  timeCell: { 
    color: '#ff0000',
    textAlign: 'center'  
  },
  tableEmailWidth: { 
    width: '80%', 
    minWidth: '300px', 
    fontSize: '1.8rem',
    textTransform: 'uppercase' 
  },
  tableFullWidth: { 
    width: '100%', 
    fontSize: '1.8rem',
    textTransform: 'uppercase' 
   },
  ul: { 
    padding: 0, 
    margin: 0, 
    listStyleType: 'none'
  },
  locationHeader: {
    backgroundColor: 'black',
    color: 'white',
    textAlign: 'center'
  }
};

export default styles;
